import api from '../../redux/api';

// Seller earning rules use a single global schema per seller:
// Base path (behind /api proxy): /v1/seller/earning-rules
const EARNING_RULES_BASE = '/v1/seller/earning-rules';

export const sellerEarningRulesService = {
  /**
   * Get current earning rule for the authenticated seller
   * GET /api/v1/seller/earning-rules
   */
  getEarningRules: async () => {
    const response = await api.get(EARNING_RULES_BASE);
    return response.data;
  },

  /**
   * Get account-level global earning rules (unchanged)
   * GET /api/account/global-settings
   */
  getGlobalEarningRules: async () => {
    const response = await api.get('/account/global-settings');
    return response.data;
  },

  /**
   * Create or update the seller earning rule
   * POST /api/v1/seller/earning-rules
   */
  createEarningRule: async (ruleData) => {
    const response = await api.post(EARNING_RULES_BASE, ruleData);
    return response.data;
  },

  /**
   * Alias for createEarningRule to keep existing callers working.
   * Backend uses POST for both create and update.
   */
  updateEarningRule: async (_ruleId, ruleData) => {
    const response = await api.post(EARNING_RULES_BASE, ruleData);
    return response.data;
  },

  /**
   * Toggle earning rule status (activate/deactivate) by id
   * PATCH /api/v1/seller/earning-rules/:id
   */
  toggleEarningRuleStatus: async (ruleId) => {
    const response = await api.patch(`${EARNING_RULES_BASE}/${ruleId}`, {});
    return response.data;
  },

  /**
   * Delete inactive earning rule by id
   * DELETE /api/v1/seller/earning-rules/:id
   */
  deleteEarningRule: async (ruleId) => {
    const response = await api.delete(`${EARNING_RULES_BASE}/${ruleId}`);
    return response.data;
  },

  /**
   * Get earning rule history list
   * GET /api/v1/seller/earning-rules/history
   */
  getEarningRulesHistory: async (params = {}) => {
    const response = await api.get(`${EARNING_RULES_BASE}/history`, { params });
    return response.data;
  },

  /**
   * Extend the date constraint of an earning rule
   * PATCH /api/v1/seller/earning-rules/:id/date-constraint
   */
  extendRule: async (ruleId, dateConstraintData) => {
    const response = await api.patch(`${EARNING_RULES_BASE}/${ruleId}/date-constraint`, dateConstraintData);
    return response.data;
  },
};

export default sellerEarningRulesService;
